module.exports = __webpack_public_path__ + "img/user_bg_0.99f4dcb4.png";